import { v4 as uuid } from 'uuid'
import {
  newfoggImg,
  newsecretImg,
  product1Img,
  product2Img,
  product3Img,
  product4Img,
  product5Img,
  product6Img,
  product7Img,
  product8Img,
  product9Img,
  product10Img,
  product11Img,
  product12Img,
  product13Img,
  product14Img,
} from '../../assets'

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    productImg: product1Img,
    title: 'Engage Blush Deodorant Spray',
    price: '270',
    prePrice: '699',
    discount: '49% off',
    rating: '5',
    category: 'Deodorant',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product2Img,
    title: 'Wild Stone Ultra Sensual Eau de Perfume',
    price: '580',
    prePrice: '789',
    discount: '34% off',
    rating: '4',
    category: 'Perfume',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product3Img,
    title: 'Nivea Pearl And Beauty Deodorant',
    price: '256',
    prePrice: '789',
    discount: '59% off',
    rating: '3',
    category: 'Deodorant',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product4Img,
    title: 'Villen classic 100ML Luxury fragrance',
    price: '370',
    prePrice: '899',
    discount: '39% off',
    rating: '4.5',
    category: 'Fragrance',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product5Img,
    title: 'FOGG Scent Jasmine 50ml Eau de Perfume',
    price: '199',
    prePrice: '499',
    discount: '59% off',
    rating: '3.5',
    category: 'Perfume',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product6Img,
    title: 'DOVE Original Deodorant Spray',
    price: '680',
    prePrice: '999',
    discount: '45% off',
    rating: '4.5',
    category: 'Deodorant',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product7Img,
    title: 'Engage Perfume Body GAS FREE Spray ',
    price: '1200',
    prePrice: '1649',
    discount: '39% off',
    rating: '5',
    category: 'BodySpray',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product8Img,
    title: 'DENVER Black Code Body Body Spray',
    price: '1170',
    prePrice: '1209',
    discount: '56% off',
    rating: '3',
    category: 'BodySpray',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product9Img,
    title: 'JAGUAR Black Eau de Toilette Perfume',
    price: '350',
    prePrice: '799',
    discount: '59% off',
    rating: '1',
    category: 'Perfume',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product10Img,
    title: 'Wild Stone LEgend, Red, US, HYDRA Body Spray',
    price: '770',
    prePrice: '1099',
    discount: '49% off',
    rating: '2.5',
    category: 'BodySpray',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product11Img,
    title: 'THE MAN COMPANY Non-Gas Body fragrance',
    price: '570',
    prePrice: '999',
    discount: '49% off',
    rating: '2',
    category: 'Fragrance',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: newsecretImg,
    title: 'Secret temptation Te Amo combo fragrance',
    price: '450',
    prePrice: '899',
    discount: '49% off',
    rating: '1',
    category: 'Fragrance',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product14Img,
    title: 'AXE Dark Temptation Long Lasting fragrance',
    price: '360',
    prePrice: '509',
    discount: '49% off',
    rating: '1.5',
    category: 'Fragrance',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: newfoggImg,
    title: 'FOGG 1 Royal and 1 Napoleon Deodorant',
    price: '670',
    prePrice: '999',
    discount: '49% off',
    rating: '2.5',
    category: 'BodySpray',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product12Img,
    title: 'HE Respect Perfumed Deodorant Spray',
    price: '470',
    prePrice: '799',
    discount: '49% off',
    rating: '3',
    category: 'Deodorant',
    quantity: 1,
  },
  {
    _id: uuid(),
    productImg: product13Img,
    title: 'Gucci Guilty BLOOM PINK Eau de Perfume',
    price: '560',
    prePrice: '909',
    discount: '49% off',
    rating: '3',
    category: 'Perfume',
    quantity: 1,
  },
]
